import { render, staticRenderFns } from "./codeInfo.vue?vue&type=template&id=00a25564&scoped=true"
import script from "./codeInfo.vue?vue&type=script&lang=js"
export * from "./codeInfo.vue?vue&type=script&lang=js"
import style0 from "./codeInfo.vue?vue&type=style&index=0&id=00a25564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a25564",
  null
  
)

export default component.exports